<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"
import { isUndefined } from "util";

    export default {
        components: {
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                formData: [
                    {
                        title: "Ancillary Mapping",
                        anchor: "2.1",
                        description: "Create an aggregation to combine ancillary items",
                        forms: [
                            {
                                label: "Mapping",
                                type: "sectionarray",
                                value: "ancillary.mappings",
                                grid: "grid-50w",
                                buttonText: "Add mapping",
                                forms: [{
                                    type: "guid",
                                    value: "id"
                                }, {
                                    type: "text",
                                    label: "Name",
                                    value: "name",
                                    required: true
                                }, {
                                    type: "typeahead",
                                    label: "Select studies",
                                    value: "studies",
									appendAll: true,
                                    required: true,
                                    multiple: true,
                                    preValues: {
                                        field: "studies",
                                        name: "name",
                                        value: "id"
                                    },
                                    callback: (formValue) => {
                                        // Cleanup selected values when deleting items
                                        this.aggregationCleanSelected(formValue, "ancillaryEquipmentDataSources");
                                    }
                                }, {
                                    type: "aggregationtable",
                                    label: "Aggregation",
                                    value: "studies",
                                    extraClass: "grid-full",
                                    searchPlaceholder: "Search studies",
                                    valueGroup: "ancillaryEquipmentDataSources",
                                    rows: (table) => {
                                        let list = [];
                                        for(let ae of table.data.ancillaryEquipments)
                                        for(let aeDun of ae.dispensingUnits){
                                            let dun = table.data.dispensingUnits.find(x => x.id === aeDun.dispensingUnit);
                                            if (this.NullOrUndefined(dun))
                                              continue;

                                            for(let dunSecPack of dun.secondaryPackages){
                                                let secPack = table.data.secondaryPackages.find(x => x.id === dunSecPack.secondaryPackages);
                                                let pp = table.data.primaryPackages.find(x => x.id === secPack.primaryPackageId);																						

                                                list.push({
                                                    id: table.studyId + "_" + table.forecastVersionId + "_" + ae.id + "_" + dun.id,
                                                    ancillaryName: ae.name,
													                          ancillaryId: ae.id,
                                                    dunId: dun.id,
                                                    dunName: dun.name,
                                                    primaryPackageName: pp.name
                                                });
                                            }
                                        }

                                        return list;
                                    },
                                    forms: [{
                                        type: "label",
                                        name: "Ancillary",
                                        value: "ancillaryName",
                                        valueId: "ancillaryId",
                                        valueGroup: "ancillaryEquipment",
                                    },{
                                        type: "label",
                                        name: "DUN",
                                        value: "dunName"
                                    },{
                                        type: "label",
                                        name: "Primary Packaging Type",
                                        value: "primaryPackageName"
                                    }]
                                }]
                            }
                        ]
                    }
                ]
            }
        }		
    }
</script>
